"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButton = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Button = _interopRequireDefault(require("../../../Buttons/Button"));

var _helperFunctions = require("../../../../styles/helperFunctions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// These const attributes are only used by the dataGrid and thus have not been extracted to a higher level at this point in time
// ...hand tuned value that makes almost no sense, i know.
var rightButtonOffset = (0, _styledComponents.css)(["left:auto;right:-", ";"], function (props) {
  return (0, _helperFunctions.joinDimensions)('*', '1.5', props.theme.standardPadding);
});
var leftButtonOffset = (0, _styledComponents.css)(["left:-", ";right:auto;"], function (props) {
  return (0, _helperFunctions.joinDimensions)('*', '1.7', props.theme.standardPadding);
}); // Begin standard pattern of exporting styled components

var StyledButton = (0, _styledComponents.default)(_Button.default).withConfig({
  displayName: "DataGridButtonstyles__StyledButton",
  componentId: "sc-1nj9tal-0"
})(["margin:0;position:relative;", ";@media only screen and (min-width:", "){", ";}"], leftButtonOffset, function (props) {
  return props.theme.smallBreak;
}, function (props) {
  if (props.alignment === 'right') {
    // this doesnt really make sense, it should be 2x but it didnt line up
    return rightButtonOffset;
  }

  if (props.alignment === 'left' || !props.alignment) {
    // this doesnt really make sense, it should be 2x but it didnt line up
    return leftButtonOffset;
  }
});
exports.StyledButton = StyledButton;